import React from "react";
import "./InputField.scss";

const InputField = ({
  placeholder,
  type,
  required,
  width = "80%",
  onChange,
  value,
  textarea,
  black,
}) => {
  return (
    <div style={{ width }} className="InputField">
      <p className="placeholder" style={{ color: black ? "black" : "grey" }}>
        {placeholder}
      </p>
      {textarea ? (
        <textarea
          type={type}
          required={required}
          onChange={onChange ? (e) => onChange(e) : null}
          value={value}
          className="field"
          cols="30"
          style={{
            borderColor: black ? "black" : "grey",
          }}
          rows="10"
        ></textarea>
      ) : (
        <input
          onChange={onChange ? (e) => onChange(e) : null}
          required={required}
          type={type}
          className="field"
          value={value}
          style={{
            borderColor: black ? "black" : "grey",
          }}
        />
      )}
    </div>
  );
};

export default InputField;
